
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic04On as ObiHydraulic04OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-04-on.js';
 
 
 

 
 export const ObiHydraulic04On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-04-on',
   elementClass: ObiHydraulic04OnElement,
   events: {
     
   }
  });
 
 